import { create } from 'zustand';

// Playback survives modal dismissal within its chat; ReadAloudHost stops it on navigation.
// Do not persist answer text/audio URLs to disk or resume after sign-out.
export const useReadAloudStore = create((set, get) => ({
  session: null,
  expanded: false,
  playback: {},
  controls: null,
  composerSlots: 0,
  start: (text) => {
    // Keep Markdown indentation until speech formatting; trimming here can turn
    // a leading indented code block into spoken prose.
    if (typeof text !== 'string' || !text.trim()) return;
    if (get().session?.text === text) {
      set({ expanded: false });
      return;
    }
    set({ session: { text, id: (get().session?.id || 0) + 1 }, expanded: false, playback: {}, controls: null });
  },
  setPlayback: (playback) => set({ playback }),
  minimize: () => set({ expanded: false }),
  expand: () => set({ expanded: true }),
  stop: () => set({ session: null, expanded: false, playback: {}, controls: null }),
}));
